<template>
  <v-card tile>
    <v-toolbar dark color="primary" style="flex-grow: 0; z-index: 100">
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-card elevation="0" tile>
        <v-card-title>{{ data.title }}</v-card-title>
        <v-card-subtitle class="pt-2" :title="dateTimeToString(data.date)">
          {{ dateToString(data.date) }}
        </v-card-subtitle>
        <v-divider />
        <scoped-page-view :html="data.content" :relative-to="data.link" />
        <v-divider />
        <meta-list-view :meta="metaInfo" :meta-desc="itemInfoMetaDesc" />
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import ScopedPageView from "@/components/ScopedPageView";
import MetaListView from "@/components/MetaListView";
import toDateString from "@/mixins/toDateString";
import metaDesc from "@/script/metaDesc";
export default {
  props: ["data"],
  mixins: [toDateString],
  components: {
    ScopedPageView,
    MetaListView,
  },
  data: () => ({
    itemInfoMetaDesc: metaDesc.itemInfo,
  }),
  computed: {
    metaInfo() {
      return {
        link: new URL(this.data.link).toString(),
        pubDate: this.data.pubDate,
        receivedDate: this.data.receivedDate,
      };
    },
  },
};
</script>